import tokens from '../tokens/js/tokens';
// Default space.
// -----------------------------------------------------------------------------
export const shape = {
    // shadows
    shadow: {
        dark: {
            '2xl': tokens.shadows.dark['2xl'].value,
            inner: tokens.shadows.dark.inner.value,
            l: tokens.shadows.dark.l.value,
            m: tokens.shadows.dark.m.value,
            s: tokens.shadows.dark.s.value,
            xl: tokens.shadows.dark.xl.value
        },
        light: {
            '2xl': tokens.shadows.light['2xl'].value,
            inner: tokens.shadows.light.inner.value,
            l: tokens.shadows.light.l.value,
            m: tokens.shadows.light.m.value,
            s: tokens.shadows.light.s.value,
            xl: tokens.shadows.light.xl.value
        }
    },
    // border-radius
    radius: {
        l: tokens.radius.lg,
        m: tokens.radius.m,
        s: tokens.radius.s
    }
};
//# sourceMappingURL=shape.js.map